import React, { createContext, useContext } from "react";
import { useConfirmDialog } from "../ui/composites/use-confirm-dialog";

const ConfirmContext = createContext(null);

/** App-wide confirm dialog — mount once in AuthenticatedLayout. */
export default function ConfirmProvider({ children }) {
  const dialog = useConfirmDialog();

  return (
    <ConfirmContext.Provider value={dialog}>
      {children}
      <dialog.ConfirmDialogHost />
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) {
    throw new Error("useConfirm must be used within ConfirmProvider");
  }
  return ctx;
}
